import {
	ConsultaExamen,
	ExamenesLabState,
	ExamenesLabViews,
	ResultadoExamen,
	SortType,
} from 'utils/interfaces';
import { ExamenesLabInitialState } from '.';
import moment from 'moment';

export type Actions =
	| { type: 'resetState' }
	| { type: 'sortResultados'; payload: boolean }
	| { type: 'nextPage' }
	| { type: 'resetPage' }
	| { type: 'setStatusMessage'; payload?: string }
	| { type: 'setView'; payload: ExamenesLabViews }
	| { type: 'showResultado'; payload?: ResultadoExamen }
	| {
			type: 'setResultados';
			payload: { resultados: ResultadoExamen[]; medico?: string };
	  }
	| { type: 'showConsultaTuMedico'; payload: boolean }
	| {
			type: 'setConsultasExamenes';
			payload: { examenes: ConsultaExamen[]; nombrePaciente: string };
	  }
	| { type: 'sortExamenesCitas'; payload: SortType }
	| { type: 'setPage'; payload: number };

const sortDates = (consultaExamenes: ConsultaExamen[], direction: SortType) => {
	const isAsc = direction === 'asc';
	return consultaExamenes.sort((a, b) => {
		if (!a.formattedFecha || !b.formattedFecha) return 0;
		if (isAsc) return a.formattedFecha.localeCompare(b.formattedFecha);
		else return b.formattedFecha.localeCompare(a.formattedFecha);
	});
};

export function reducer(
	state: ExamenesLabState,
	action: Actions
): ExamenesLabState {
	switch (action.type) {
		case 'setView': {
			return {
				...state,
				view: action.payload,
			};
		}
		case 'resetState': {
			return ExamenesLabInitialState;
		}
		case 'setStatusMessage': {
			return {
				...state,
				statusMessage: action.payload,
			};
		}
		case 'setConsultasExamenes': {
			const { examenes: resultados, nombrePaciente } = action.payload;
			const consultaExamenes = resultados.map((examen) => ({
				...examen,
				formattedFecha: moment(examen.fechaEmision, 'DD/MM/YYYY').format(
					'YYYY/MM/DD'
				),
			}));
			return {
				...state,
				view: 'response',
				consultaExamenes,
				nombrePaciente,
			};
		}
		case 'setResultados': {
			const { medico, resultados } = action.payload;
			return {
				...state,
				medico,
				resultados,
				view: 'results',
				totalPages: Math.ceil(resultados.length / state.perPage),
				resultsInPage: [...resultados].slice(0, state.perPage),
			};
		}
		case 'showResultado': {
			const resultado = action.payload;
			return {
				...state,
				resultado,
				showResultadoModal: Boolean(resultado),
			};
		}
		case 'showConsultaTuMedico': {
			return {
				...state,
				showConsultaTuMedicoModal: action.payload,
			};
		}
		case 'sortExamenesCitas': {
			const sortedConsultaExamenes = sortDates(
				state.consultaExamenes,
				action.payload
			);
			return {
				...state,
				sort: action.payload,
				consultaExamenes: sortedConsultaExamenes,
			};
		}
		case 'setPage': {
			return {
				...state,
				page: action.payload,
			};
		}
		case 'nextPage': {
			if (state.page >= state.totalPages) {
				return state;
			}

			const newPage = state.page + 1;
			const resultsInPage = [...state.resultados].slice(
				0,
				newPage * state.perPage
			);

			return {
				...state,
				page: newPage,
				resultsInPage,
			};
		}
		case 'resetPage': {
			const resultsInPage = [...state.resultados].slice(0, state.perPage);
			return {
				...state,
				page: 1,
				resultsInPage,
			};
		}
		case 'sortResultados': {
			return {
				...state,
				sortResultados: action.payload,
			};
		}
		default:
			return state;
	}
}
